<template>
  <div class="outer" ref="parent" :data-scrolled="scrolled">
      <div class="ms ms--regular pageslide" :class="index === activeSlide ? 'active' : 'inactive'" ref="scroller" @scroll="checkScroll" :data-id="index">
            <div class="ms__wrap c c--content--pad r pad--h v--40">
                <div class="ms__top">
                    <div ref="content" class="ms__content v--20">
                        <div v-for="instance in sd.panels_meta.widgets" :key="instance.panels_info.id">
                            <PanelText v-if="instance.panels_info.class === 'Text_Panel'" :instance="instance" :siloData="siloData" :active="active"/>
                            <PanelEmbed v-if="instance.panels_info.class === 'Embed_Panel'" :appState="appState" :instance="instance" :active="active" :pauseVideo="pauseVideo" v-bind:allowNext="false" @playingVideo="playingVideo"/>
                            <PanelShowHide v-if="instance.panels_info.class === 'Show_Hide_Panel'" :instance="instance" :siloData="siloData"/>
                            <PanelForm v-if="instance.panels_info.class === 'Form'" :instance="instance" :siloData="siloData" :slide="slides[0]" :active="active" :pauseVideo="pauseVideo" :isLast="isLast" @next="next" @processing="setProcessing" @refreshData="refreshData" @setNextOnRefresh="setNextOnRefresh" @playingVideo="playingVideo" @updateState="updateState" @toMenu="close"/>
                            <Pushmanager v-if="instance.panels_info.class === 'Pushmanager'" :instance="instance" :siloData="siloData" :slide="slides[0]" :active="active"/>
                            <PanelAudio v-if="instance.panels_info.class === 'Audio_Panel'" :instance="instance" :siloData="siloData" :active="active" :pauseVideo="pauseVideo" :isLast="isLast" @playingVideo="playingVideo"/>
                            <PanelVariable v-if="instance.panels_info.class === 'Variable_Panel'" :instance="instance" :siloData="siloData"/>
                            <GoalEditScreen v-if="instance.panels_info.class === 'Goal_Edit_Screen'" :instance="instance" :siloData="siloData" @next="next"/>
                            <Uconditional
                            v-if="instance.panels_info.class === 'Ultra_Conditional'"
                                :instance="instance"
                                :siloData="siloData"
                                :pauseVideo="pauseVideo"
                                :active="active"
                                :slide="slides[0]"
                                :isLast="isLast"
                                @next="next"
                                @prev="prev"
                                @processing="setProcessing"
                                @refreshData="refreshData"
                                @setNextOnRefresh="setNextOnRefresh"
                                @playingVideo="playingVideo"
                                @toMenu="$emit('toMenu')"
                            />
                        </div>
                    </div>
                </div>
                <div v-if="sd.hide_next_button !== 'true'" class="ms__buttons r r--halign-center">
                    <template v-if="slides.length === 1">
                        <!-- Topic finish button (Topics menu) -->
                        <button v-if="!hideButton" class="ms__home btn btn--solid" @click="$emit('close')" aria-label="Return home">Finish</button>
                    </template>
                    <template v-else>
                        <!-- regular next button -->
                        <button v-if="!isLast && !hideButton" class="ms__next btn btn--solid" @click="next" v-text="isFirst? 'Start' : 'Next'">Next</button>

                        <template v-if="isLast && !hideButton">
                            <button v-if="isRestart" class="ms__home btn btn--solid" @click="$emit('restart')" aria-label="Finish">Finish</button>
                            <button v-if="!isRestart" class="ms__home btn btn--solid" @click="$emit('close')" aria-label="Return home">Finish</button>
                        </template>

                    </template>
                </div>
                <template v-if="sd.show_skip_button === 'true'">
                    <div class="ms__skip r r--halign-center">
                        <button class="ms__skip__button btn btn--text" @click="$emit('close')">Skip</button>
                    </div>
                </template>
            </div>
        </div>
  </div>
</template>

<script>
import PanelText from "@c/panels/PanelText.vue";
import PanelEmbed from "@c/panels/PanelEmbed.vue";
import PanelShowHide from "@c/panels/PanelShowHide.vue";
import PanelForm from "@c/panels/PanelForm.vue";
import Icon from "@c/Icon.vue";
import Pushmanager from "@c/panels/Pushmanager.vue";
import PanelAudio from "@c/panels/PanelAudio.vue";
import PanelVariable from "@c/panels/PanelVariable.vue";
import GoalEditScreen from "@c/panels/GoalEditScreen.vue";
import Uconditional from "@c/panels/Uconditional.vue";

export default {
        components: {
        PanelText,
        PanelEmbed,
        PanelShowHide,
        Icon,
        PanelForm,
        Pushmanager,
        PanelAudio,
        PanelVariable,
        GoalEditScreen,
        Uconditional,
    },
	props: {
		sd: Object, // aka 'slide data'
        index: Number, // the index of this slide
        slides: Array, // all slide data
        siloData: Object,
        appState: String,
        // activeSlide: Number,
        activeSlide: String,
        active: Boolean,
	},
    data() {
        return {
            pauseVideo: true,
            scrolled: false,
        } 
    },
    mounted() {
        this.updateLinks();
    },
    watch: {
        active() {
            if (this.active === true) {
                this.resetScroll();
            }
        }
    },
    computed: {
        // Adds 1 to index, since index is always based on 0
        actualIndex() {
            return this.index + 1;
        },
        isFirst() {
            return this.actualIndex === 1 ? true : false;
        },
        isLast() {
            return this.actualIndex === this.slides.length ? true : false;
        },
        isRestart() {
            return this.sd.finish_button_function === 'restart' ? true : false;
        },
        // Check to see if the slide has a form panel or any other one where we need to hide the button
        hideButton() {
            let returned = false;

            if (this.sd.panels_meta.widgets === undefined) { return false; }

            // Loop through panel widgets
            this.sd.panels_meta.widgets.forEach(instance => {
                // If we find a form panel, set the return to true
                if (instance.panels_info.class === 'Form' || instance.panels_info.class === 'Video_Team_Panel' || instance.panels_info.class === 'Audio_Panel' || instance.panels_info.class === 'Conditional' || instance.panels_info.class === 'Mconditional' || instance.panels_info.class === 'Ultra_Conditional') {
                    returned = true;
                }
                // Hide the button if it's an embed panel AND it's required, otherwise use the module button
                if (instance.panels_info.class === 'Embed_Panel' && instance.required === true) {
                    returned = true;
                }
            });

            return returned;
        },
    },
    methods: {
        // Go through the links and update them so they navigate within the content of the app
        updateLinks() {

            if (this.$refs.content === undefined) { return; }

            let anchors = this.$refs.content.getElementsByTagName('a');

            if (anchors === undefined || anchors.length === 0) { return false; }
            anchors.forEach((anchor) => {
                // Make sure it isn't an external link (we want those)
                if (anchor.target !== "_blank" && anchor.dataset.function !== "updateState") {
                    // Save the url
                    let saved_href = anchor.href;
                    // Change the current url to pound
                    anchor.href="#";
                    // Break up url into pieces
                    let url_pieces = saved_href.split("/");
                    // Get the final url piece which should be our slug
                    let slug = url_pieces[url_pieces.length - 2];

                    //let final_slug = slug.replace('-','');

                    anchor.onclick = function() { window.pageLoader.set(slug); return false; };
                }

                if (anchor.dataset.function === "updateState") {
                    anchor.href="#";
                    anchor.onclick = function() { window.appManager.updateState(anchor.dataset.state); return false; }
                }
            });
        },
        home() {
            // emit prev to parent
            this.$emit('home');
            this.pauseVideo = true;
        },
        close() {
            console.log('page slide: closing page slide');
            this.resetScroll();
            // emit prev to parent
            this.$emit('close');
            this.pauseVideo = true;
        },
        next() {
        console.log('emitting next');
            // emit next event to parent
            this.$emit('next');
            this.pauseVideo = true;
        },
        prev() {
            // emit prev to parent
            this.$emit('prev');
            this.pauseVideo = true;
        },
        setProcessing(state) {
            //console.log('setting processing (module slide)');
            this.$emit('processing', state);
        },
        refreshData(onComplete = null) {
            //console.log('refreshing data (module slide)');
            this.$emit('refreshData', onComplete);
        },
        setNextOnRefresh() {
            console.log('SETTING NEXT ON REFRESH setting next on refresh (page slide)');
            this.$emit('setNextOnRefresh');
            this.pauseVideo = true;
        },
        // Emitted when playing a video
        playingVideo() {
            this.pauseVideo = false;
        },
        updateState(newState) {
            this.$emit('updateState', newState);
        },
        // Check to see if we've scrolled in the parent frame
        checkScroll() {
            if (this.$refs.parent === undefined) { return; }

            // 88 is the height of the header area
            if (this.$refs.scroller.scrollTop > 35) {
                this.scrolled = true;
            } else {
                this.scrolled = false;
             };
       },
       // Reset the scroll back to 0
       resetScroll() {
            this.$refs.scroller.scrollTop = 0;
       },
    }
}
</script>

<style lang="scss" scoped>
@import "@s/_mixins.scss";
@import "@s/_vars.scss";
.outer {
    width: 100%;
    height: 100%;
        &[data-scrolled="true"] {
        .ms__wrap {
            &:before {
                opacity: 1;
            }
        }
    }
}
.ms--page {
    height: 100vh;
    padding-top: 0;
    background-color: var(--color-white);
    padding-bottom: rem(90px);
    // The first page has no breadcrumb so it needs some padding difference
    &[data-id="0"] {
        .ms__content {
            //padding-top: rem(20px);
        }
    }
}
.ms__skip {
    margin-top: rem(-100px);
    padding-bottom: rem(40px);
}
.ms__wrap {
    padding-bottom: rem(90px);
    transition: all 0.5s;
        &:before {
        content: "";
        display: block;
        width: 100%;
        height: rem(10px);
        //background: #095656;
        background:     radial-gradient(
            farthest-side at 50% 0,
            rgba(var(--color-sp-emerald-rgb), 0.2),
            rgba(var(--color-sp-emerald-rgb), 0),
            ) center top;
        position: sticky;
        top: 0;
        left: 0;
        right: 0;
        opacity: 0;
        transition: opacity 0.15s;
        z-index: 2;
    }
}
.ms {
    padding-bottom: rem(50px);
}
</style>